export type LocaleOption = {
  locale: string;
  name: string;
};

type TrainingAvailableLocale = {
  locale: string;
  name?: string | null;
  text: string | null;
};

type TrainingLocalesSource = {
  availableLocales?: TrainingAvailableLocale[] | null;
};

const DEFAULT_LOCALE: LocaleOption = { locale: 'es', name: 'Spanish' };

export function getTrainingLocales(
  training: TrainingLocalesSource | null | undefined
): LocaleOption[] {
  const available = training?.availableLocales;
  if (!available?.length) return [DEFAULT_LOCALE];

  const withText = available.filter(item => item.locale && item.text);
  const source = withText.length
    ? withText
    : available.filter(item => item.locale);
  if (!source.length) return [DEFAULT_LOCALE];

  const byLocale: Record<string, LocaleOption> = {};
  for (const item of source) {
    byLocale[item.locale] ??= {
      locale: item.locale,
      name: item.name || item.locale
    };
  }

  return Object.values(byLocale);
}
